export { default as ListarRegiones } from './Listar';
export { default as NuevaRegiones } from './Crear';